import numeral from 'numeral'
import moment from 'moment'
import _ from 'lodash';
import { UNIT_SYSTEM } from '../constants/UnitConsts';
import { convertDistance, getUnitLabel } from './helper';

export const initFilters = Vue => {
  Vue.filter('number', function (value, decimals) {
    decimals = decimals ? `${'000000000'.slice(0, decimals)}` : 0

    return numeral(value).format(`0,0${decimals ? '.' + decimals : ''}`)
  })

  Vue.filter('date', function (value, format) {
    return moment(value).format(format)
  })

  Vue.filter('dateLocale', function (value, locale, format) {
    return moment(value).locale(locale).format(format)
  })

  Vue.filter('secondsToMinutes', function(value) {
    return Math.round(Math.abs(value) / 60)
  })

  Vue.filter('secondsToMinutesRoundedUp', function(value) {
    return Math.ceil(Math.abs(value) / 60)
  })
  
  Vue.filter('secondsToMinutesSeconds', function (seconds){
      var formattedMinutes = _.padStart(Math.floor(seconds / 60).toString(), 2, '0');
      var formattedSeconds = _.padStart((seconds % 60).toString(), 2, '0');
  
      return formattedMinutes + ':' + formattedSeconds;
  });

  Vue.filter('secondsToMinutesSecondsReduced', function (seconds){
    var formattedMinutes = _.padStart(Math.floor(seconds / 60).toString(), 0, '0');
    var formattedSeconds = _.padStart((seconds % 60).toString(), 2, '0');

    if(formattedSeconds === '00') {
      if(formattedMinutes === '00') {
        return 0;
      }
      
      return formattedMinutes;
    }

    return formattedMinutes + ':' + formattedSeconds;
  });

  Vue.filter('distance', function (value, unit, joined = ' ') {
    return unit === UNIT_SYSTEM.IMPERIAL ? `${numeral(convertDistance(value, UNIT_SYSTEM.IMPERIAL)).format('0,0.00')}${joined}${getUnitLabel(unit)}` : `${numeral(value).format('0,0')}${joined}${getUnitLabel(unit)}`
  })
  
}
